<template>
    <ShinseiDetailNoApproval />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import ShinseiDetailNoApproval from '@/components/shinsei/detail/FormNoApproval.vue'


/*
下記課題対応の際に仮実装したもの
MEDICA_AS-1108 申請一覧 申請種別に「早番遅番」と「公休」を追加する

ただし下記コメントの通り田中さん指示では不要とのことなので未使用です。
https://imp-hd.backlog.com/view/MEDICA_AS-1108#comment-324690308

基本的な情報表示はOKなので使う際はテストのうえ使用してください。
承認フローが無い申請なので各種操作ボタンは未実装です。
*/

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      ShinseiDetailNoApproval
    }
})
</script>
